var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 76,
    viewBox: "0 0 53 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4912 71.4864C16.896 71.4864 6.22081 59.4288 4.37761 43.0704C4.14721 41.4576 4.0704 39.8448 4.0704 38.1552C4.0704 19.5696 15.4368 4.7472 29.4912 4.7472C36.864 4.7472 43.776 8.8176 49.0752 16.8816L52.5312 14.5776C46.464 5.592 38.1696 0.676804 29.4912 0.676804C13.2864 0.676804 0 17.6496 0 38.1552C0 39.9216 0.0768144 41.7648 0.307214 43.5312C2.30401 61.656 15.0528 75.5568 29.4912 75.5568C38.1696 75.5568 46.464 70.6416 52.5312 61.7328L49.0752 59.4288C43.776 67.416 36.864 71.4864 29.4912 71.4864Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperC);
export default __webpack_public_path__ + "static/media/UPPER_C.7b16f8a4b60e2b2de31d2c4b79c8da91.svg";
export { ForwardRef as ReactComponent };